import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { connectRoutes } from "@circle-react/lib/routes/connect";
import { settingsRoutes } from "@circle-react/lib/routes/settings";

import { t } from "@/i18n-js/instance";

import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const useSettingsLinks = (): Link[] => {
  const { currentCommunitySettings } = usePunditUserContext();

  return [
    {
      label: t("customize_theme.title"),
      path: settingsRoutes.theme(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.settings.general"),
      path: settingsRoutes.general(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.settings.custom_domain"),
      path: settingsRoutes.customDomain(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.site.mobile_app"),
      path: settingsRoutes.mobileApp(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.settings.weekly_digest"),
      path: settingsRoutes.weeklyDigest(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.settings.embed"),
      path: settingsRoutes.embed(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.settings.single_sign_on"),
      path: settingsRoutes.singleSignOn(),
      exact: true,
    },
    ...(currentCommunitySettings?.circle_integrations
      ? [
          {
            label: t("settings_nav_v3.settings.integrations"),
            path: settingsRoutes.integrations(),
            exact: true,
          },
        ]
      : []),
    {
      label: t("settings_nav_v3.settings.connect"),
      path: connectRoutes.communitySettings(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.settings.legal"),
      path: settingsRoutes.legal(),
      exact: true,
    },
  ];
};

export const SettingsLinks = () => {
  const links = useSettingsLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.settings.label")}>
        {links.map(link => (
          <SubNavLinkItem key={link.path} label={link.label} to={link.path} />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
